import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import Switch from '../../../forms/Switch';

// Matches any 3p IAS measurement domain. Kept aligned with the backend's
// IAS_INTERNAL_PIXEL_AUTO_DETECT_PATTERN so the UI default agrees with what
// the server would compute.
const IAS_3P_PIXEL_PATTERN = /https:\/\/(?:pixel|vast)\.adsafeprotected\.com/i;

export default function IasInternalPixel() {
  const { control, setValue, getFieldState, getValues } = useFormContext();
  const autoTag = useWatch({ control, name: 'autoTag' });
  const tag = useWatch({ control, name: 'tag' });

  useEffect(() => {
    // Once the user manually toggles the switch, its dirty flag is set and
    // we stop auto-syncing — the AC says "User should be able to disable
    // the IAS internal pixel", which we interpret as: their explicit choice
    // wins.
    if (getFieldState('appendIasInternalPixel').isDirty) return;

    const source = `${autoTag || ''} ${tag || ''}`;
    const hasIas = IAS_3P_PIXEL_PATTERN.test(source);
    if (hasIas !== getValues('appendIasInternalPixel')) {
      // shouldDirty: false — leaves the form clean so a no-op auto-detect
      // doesn't enable the Save button on a freshly loaded creative.
      setValue('appendIasInternalPixel', hasIas, { shouldDirty: false });
    }
  }, [autoTag, tag, getFieldState, getValues, setValue]);

  return <Switch name="appendIasInternalPixel" label="Append IAS Internal Pixel" />;
}
